import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'

interface Props {
  vm: JobProgressionViewModel
}

export default observer(function JobExtensionConfirmedProgressionActions({
  vm,
}: Props) {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.answerJobExtensionAccepted()}
          dataTest="job-progression-set-extension-approved-button"
        >
          Extension Accepted
        </Button>
      </CardContent>

      <CardContent>
        <Button
          type="danger"
          size="wide-slim"
          onClick={() => vm.answerJobExtensionRejected()}
          dataTest="job-progression-set-extension-rejected-button"
        >
          Extension Rejected
        </Button>
      </CardContent>
    </>
  )
})
